import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import ServiceDetail from "@/pages/ServiceDetail";
import Pribehy from "@/pages/Pribehy";
import PribehyDetail from "@/pages/PribehyDetail";
import Clanky from "@/pages/Clanky";
import ClankyDetail from "@/pages/ClankyDetail";
import Podcasty from "@/pages/Podcasty";
import PodcastyDetail from "@/pages/PodcastyDetail";
import Admin from "@/pages/Admin";
import ClientPass from "@/pages/ClientPass";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { CookieConsent } from "@/components/CookieConsent";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

// SPA: při změně stránky (bez reloadu) pošle page_view — jen pokud návštěvník
// udělil souhlas a gtag je skutečně načtený (viz CookieConsent).
const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function" && process.env.REACT_APP_GA_ID) {
      window.gtag("config", process.env.REACT_APP_GA_ID, {
        page_path: location.pathname + location.search + location.hash,
      });
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pojisteni/:slug" element={<ServiceDetail />} />
          <Route path="/pribehy" element={<Pribehy />} />
          <Route path="/pribehy/:slug" element={<PribehyDetail />} />
          <Route path="/rady" element={<Clanky />} />
          <Route path="/rady/:slug" element={<ClankyDetail />} />
          <Route path="/podcasty" element={<Podcasty />} />
          <Route path="/podcasty/:slug" element={<PodcastyDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/pas/:token" element={<ClientPass />} />
          <Route path="/ochrana-osobnich-udaju" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="bottom-center" />
        <FloatingWhatsApp />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
